import script from "./CUOutboundOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./CUOutboundOrder.vue?vue&type=script&setup=true&lang=js"

import "./CUOutboundOrder.vue?vue&type=style&index=0&id=0e05b612&lang=css"

const __exports__ = script;

export default __exports__